import React, { ReactNode } from 'react'
import classNames from 'classnames'

import style from './style.module.scss'

type Props = {
  children: ReactNode
  className?: string
}

function HeaderOne(props: Props) {
  const { children, className } = props
  return <h1 className={classNames(style.wrapper, className)}>{children}</h1>
}

export default HeaderOne
